import GalleryGrid from '../../components/GalleryGrid/GalleryGrid';
import AwardCard from '../../components/AwardCard/AwardCard';
import ReviewCard from '../../components/ReviewCard/ReviewCard';
import './Gallery.css';

const galleryImages = [
  { src: '/images/Restaurant_interior_with_elegant_lighting.png', alt: 'Restaurant interior with elegant lighting', span: 'feature' },
  { src: '/images/Grilled_salmon_with_seasonal_vegetables.png', alt: 'Grilled Salmon with seasonal vegetables' },
  { src: '/images/Ribeye_steak_with_garlic_mashed_potatoes.png', alt: 'Ribeye Steak with garlic mashed potatoes' },
  { src: '/images/Private_dining_area.png', alt: 'Private dining area', span: 'wide' },
  { src: '/images/Tiramisu%20dessert.png', alt: 'Tiramisu dessert' },
  { src: '/images/Chef_preparing_a_dish.png', alt: 'Chef preparing a dish in the kitchen', span: 'feature' },
];

const awards = [
  { title: 'Culinary Excellence Award', year: '2022' },
  { title: 'Restaurant of the Year', year: '2023' },
  { title: 'Best Fine Dining Experience — Foodie Magazine', year: '2023' },
];

const reviews = [
  {
    quote: 'Exceptional ambiance and unforgettable flavors.',
    source: 'Gourmet Review',
  },
  {
    quote: 'A must-visit restaurant for food enthusiasts.',
    source: 'The Daily Bite',
  },
];

function Gallery() {
  return (
    <div className="gallery-page">
      {/* Immersive Gallery */}
      <section className="gallery-page__gallery">
        <GalleryGrid images={galleryImages} />
      </section>

      {/* Awards */}
      <section className="gallery-page__awards section">
        <div className="container">
          <h2 className="section-title" style={{ color: 'var(--color-text-light)' }}>
            Awards & Recognition
          </h2>
          <div className="section-divider"></div>
          <div className="gallery-page__awards-grid">
            {awards.map((award, index) => (
              <AwardCard key={index} {...award} />
            ))}
          </div>
        </div>
      </section>

      {/* Reviews */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">What People Are Saying</h2>
          <div className="section-divider"></div>
          <div className="gallery-page__reviews-grid">
            {reviews.map((review, index) => (
              <ReviewCard key={index} {...review} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Gallery;
